import { useMutation } from '@tanstack/react-query';
import { uploadMedia as uploadMediaApi } from '../../api/apiMedias';
import toast from 'react-hot-toast';

export const useUploadMedia = () => {
    const { mutate: uploadMediaMutation, isPending: isUploading } = useMutation({
        mutationFn: uploadMediaApi,
        onSuccess: (response) => {
            toast.success(response.message || 'File uploaded successfully');
            return response;
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Upload failed';
            toast.error(errorMessage);
            throw error;
        },
    });

    const uploadMedia = (file) => {
        return new Promise((resolve, reject) => {
            uploadMediaMutation(file, {
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            });
        });
    };

    return {
        uploadMedia,
        isUploading,
    };
};
